import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Paper from '@/components/Paper'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import useUrlSearchParams from '@/hooks/useUrlSearchParams'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { getScopes } from '../../../services'
import { getScopeColumns } from './columns'
import { Scope } from '../../../types'

const ScopesList = () => {
    const { t } = useTranslation()

    const { queryParams, searchInputProps } = useUrlSearchParams()

    const apiParams = useMemo(
        () => ({
            name: queryParams.q || undefined,
            max: 1000,
        }),
        [queryParams.q]
    )

    const {
        data: scopesData,
        renderState,
        isFetching,
    } = useQueryWithHandler(
        {
            queryKey: [QUERY_KEYS.AUTHORIZATION_SCOPES, apiParams],
            queryFn: () => getScopes(apiParams),
            placeholderData: true,
        },
        { showLoading: true, showError: true }
    )

    const rows = scopesData?.results || []
    const columns = useMemo(() => getScopeColumns(), [])

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <Paper>
            <DataTableCustomized<Scope>
                columns={columns}
                rows={rows}
                rowKey={(row) => row.id}
                isFetching={isFetching}
                emptyMessage={t('noData', 'Không có dữ liệu')}
                pagination={{
                    page: 1,
                    pageSize: 20,
                    total: rows.length,
                }}
                toolbar={{
                    search: {
                        ...searchInputProps,
                        placeholder: t('search'),
                    },
                }}
                bordered
            />
        </Paper>
    )
}

export default ScopesList
